export default __webpack_public_path__ + "static/duncan-5236b23fcc27b06b6a45b76ada3f96e7.png";